import React from 'react'
import defaultProgramThumb from '../../assets/img/default-program.png'
import { useDateFormatter } from '../../hooks/useDateFormatter'
import { Card, CardContent } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import ActionsMenu from '../ActionsMenu/ActionsMenu'

const ProgramCard = ({
  program,
  setProgramToEdit,
  setShowAddEditProgram,
  setShowDeleteModal,
  setProgramToDelete,
}) => {
  const handleEditProgram = () => {
    setProgramToEdit(program)
    setShowAddEditProgram(true)
  }

  const handleDeleteProgram = () => {
    setShowDeleteModal(true)
    setProgramToDelete(program)
  }

  return (
    <div className={`card-wrapper program`}>
      <Card className={`white-card`}>
        <div
          className={`thumbnail-container no-thumbnail`}
          style={{
            backgroundImage: `url(${defaultProgramThumb})`,
          }}
        ></div>

        <CardContent>
          <div className="content">
            <div className="flex align-center">
              <h4 className="m-b-0">{program.name}</h4>
              <ActionsMenu
                icon={<ArrowDropDown />}
                options={[
                  { onClick: handleEditProgram, label: 'Edit' },
                  { onClick: handleDeleteProgram, label: 'Delete' },
                ]}
              ></ActionsMenu>
            </div>

            <p>{program.model}</p>

            <div className="flex space-between last-updated">
              <p>
                <strong className="primary">Last updated:</strong>
              </p>
              <p>{useDateFormatter(program.updatedAt)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default ProgramCard
